import { MdInfoOutline } from 'react-icons/md'

import type { ReactElement } from 'react'

import Button from '~/components/Buttons/Button'
import ModalDialog from '~/components/ModalDialog'

import './styles.scss'

interface Props {
  isOpen: boolean
  mainText: string
  onClose: VoidFunction
  onConfirm: VoidFunction
  subText: string
}

const ResetWarningModal = ({ isOpen, mainText, onClose, onConfirm, subText }: Props): ReactElement => {
  return (
    <ModalDialog
      btnConfirm={
        <Button className="reset-modal-confirm" onClick={onConfirm}>
          Continue
        </Button>
      }
      className="reset-modal"
      icon={<MdInfoOutline color="#e8af1c" size={42} />}
      isOpen={isOpen}
      mainText={mainText}
      onClose={onClose}
      onConfirm={onConfirm}
      subText={subText}
    />
  )
}

export default ResetWarningModal
